import { render, staticRenderFns } from "./tasklist.vue?vue&type=template&id=0b2cba49&scoped=true"
import script from "./tasklist.vue?vue&type=script&lang=js"
export * from "./tasklist.vue?vue&type=script&lang=js"
import style0 from "./tasklist.vue?vue&type=style&index=0&id=0b2cba49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2cba49",
  null
  
)

export default component.exports